import React, { useRef, useState, lazy, Suspense } from "react";

// Components
import TrackingFormParent from "../components/tracking/tracking/TrackingFormParent";
import { trackingViews } from "../constants/tracking";

// Helpers, hooks etc.
import { useAutoIframeHeight } from "../hooks/utility";

const TrackingResults = lazy(() =>
  import("../components/tracking/tracking/TrackingResults")
);

const Tracking = () => {
  const containerRef = useRef();
  useAutoIframeHeight(containerRef);

  const [activeView, setActiveView] = useState(trackingViews.trackingForm);

  return (
    <div ref={containerRef}>
      <Suspense fallback={<div className="loading" />}>
        {trackingViews.trackingForm === activeView ? (
          <TrackingFormParent
            setActiveView={setActiveView}
            views={trackingViews}
          />
        ) : (
          <TrackingResults
            setActiveView={setActiveView}
            views={trackingViews}
          />
        )}
      </Suspense>
    </div>
  );
};
export default Tracking;
